var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"size-ob",rawName:"v-size-ob",value:(_vm.handleChange),expression:"handleChange"}],staticClass:"XScroll-container"},[_c('div',{staticClass:"v-scroll"},[_c('div',{staticClass:"content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }